export default __webpack_public_path__ + "static/media/icono-redireccion-morado.332f2852.svg";